import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import {  Card, Col,  Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import CardMenuSetting from "./CardMenuSetting";
import MenuLogout from "./MenuLogout";

const ProfileSetting = () => {
  const navigate = useNavigate();

  const sectionOne = [
    {
      title: "โปรไฟล์ของฉัน",
      
      func: () => {
        navigate("/profiles/setting-my-profile");
      },
    },
    {
      title: "คิวอาร์โค้ดของฉัน",
      
      func: () => {
        navigate("/profiles/my-qrcode");
      },
    },
    {
      title: "ตั้งค่าโรงพยาบาล",
      
      func: () => {
        navigate("/profiles/setting-factory");
      },
    },
    {
      title: "ตั้งค่าแจ้งเตือนผ่านไลน์",
      
      func: () => {
        navigate("/profiles/setting-line-alert");
      },
    },
  ];

  const sectionTwo = [
    {
      title: "แชทและข้อความอัตโนมัติ",
      
      func: () => {
       // navigate("/campaign");
      },
    },
    {
      title: "การแจ้งเตือน",
      
      func: () => {
       // navigate("/manage-product");
      },
    },
    {
      title: "ความปลอดภัยและความเป็นส่วนตัว",
      
      func: () => {
       // navigate("/manage-product");
      },
    },
    {
      title: "การรายงาน",
      
      func: () => {
       // navigate("/manage-product");
      },
    },
  ];

  const sectionThree = [
    {
      title: "ศูนย์ช่วยเหลือ",
      
      func: () => {
       // navigate("/campaign");
      },
    },
    {
      title: "นโยบาย",
      
      func: () => {
       // navigate("/manage-product");
      },
    },
    {
      title: "เกี่ยวกับ",
      
      func: () => {
       // navigate("/manage-product");
      },
    },
    {
      title: "คำขอลบบัญชีผู้ใช้",
      
      func: () => {
       // navigate("/manage-product");
      },
    },
  ];

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/profiles");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>ตั้งค่าบัญชีผู้ใช้</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <TitleWrapper>
                <Typography.Text style={{ color: "#A0A0A0", marginLeft: 20, marginTop: 10 }} >บัญชีของฉัน</Typography.Text>
              </TitleWrapper>
            <Row
                gutter={[8, 0]}
                style={{
                  backgroundColor: "#EFEFEF",
                  overflow: "auto",
                  padding: "10px 0px 0px 0px",
                }}
              >
                {sectionOne.map((item, index) => {
                  return (
                    <CardMenuSetting
                      key={index}
                      title={item.title}
                      func={item.func}
                    />
                  );
                })}
              </Row>
              <TitleWrapper>
                <Typography.Text style={{ color: "#A0A0A0", marginLeft: 20, marginTop: 10 }} >การตั้งค่า</Typography.Text>
              </TitleWrapper>
            <Row
                gutter={[8, 0]}
                style={{
                  backgroundColor: "#EFEFEF",
                  overflow: "auto",
                  padding: "10px 0px 0px 0px",
                }}
              >
                {sectionTwo.map((item, index) => {
                  return (
                    <CardMenuSetting
                      key={index}
                      title={item.title}
                      func={item.func}
                    />
                  );
                })}
              </Row>
              {/* <TitleWrapper>
                <Typography.Text style={{ color: "#A0A0A0", marginLeft: 20, marginTop: 10 }} >การตั้งค่า</Typography.Text>
              </TitleWrapper>
            <Row
                gutter={[8, 0]}
                style={{
                  backgroundColor: "#EFEFEF",
                  overflow: "auto",
                  padding: "10px 0px 0px 0px",
                }}
              >
                {sectionTwo.map((item, index) => {
                  return (
                    <CardMenuSetting
                      key={index}
                      title={item.title}
                      func={item.func}
                    />
                  );
                })}
              </Row> */}
              <Row
                gutter={[8, 0]}
                style={{
                  backgroundColor: "#EFEFEF",
                  overflow: "auto",
                  padding: "10px 0px 0px 0px",
                }}
              >
                <MenuLogout />
              </Row>
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ProfileSetting;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
`;
